export default __webpack_public_path__ + "static/media/huaxue.83b1afe6.png";